import { rm } from 'utils';
import { IQuantity } from 'models/IQuantity';
import { ConfiguratorBase } from 'models/ConfiguratorBase';
import { MultiQuantity } from 'models/MultiQuantity';

export const validate = (
  props: {
    isFamily: boolean;
    quantity: IQuantity & Partial<MultiQuantity>;
    customOptions: ConfiguratorBase['attributes'];
  },
  amount: number
): { isValid: boolean; message: string | string[] } => {
  if (props.isFamily) {
    return { isValid: false, message: rm('product_validation_isfamily') };
  }
  if (amount < props.quantity.lowest) {
    if (props.quantity.factor !== undefined && props.quantity.salesUnit !== undefined) {
      return {
        isValid: false,
        message: rm('product_validation_qtylow', props.quantity.lowest, props.quantity.salesUnit)
      };
    }

    return {
      isValid: false,
      message: rm('product_validation_qtylow', props.quantity.lowest, props.quantity.unit)
    };
  }
  if (amount > props.quantity.highest) {
    return {
      isValid: false,
      message: rm('product_validation_qtyhigh', props.quantity.highest, props.quantity.unit)
    };
  }
  if (props.customOptions.length > 0) {
    return {
      isValid: false,
      message: props.customOptions.map(a => rm('product_validation_customoption', a.name))
    };
  }
  return { isValid: true, message: '' };
};
